import type { JSXElement } from 'solid-js'
import { Motion } from 'solid-motionone'

export function MotionDiv(props: {
  delay: number
  class?: string
  children: JSXElement
}) {
  return (
    <Motion.div
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.7, delay: props.delay }}
      class={props.class}
    >
      {props.children}
    </Motion.div>
  )
}
